import { mapActions } from 'vuex'
export const UserShippingDetails = {
  name: 'MyShippingDetails',
  data () {
    return {
      shippingDetails: {
        street: '',
        telephone: '',
        firstname: '',
        lastname: '',
        comment: '',
        house: '',
        apartment: '',
        city: '',
        postcode: '',
        state: '',
        country: '',
        default_shipping: false,
        longitude: '',
        latitude: '',
        api_details: ''
      },
      otherReceiver: false,
      fieldsType: '',
      currentEditableAddress: 0,
      addressFormDisplayed: false
    }
  },
  beforeMount () {
    this.$bus.$on('customer-display-shipping-address-form', this.displayAddressForm)
  },
  methods: {
    ...mapActions({
      create: 'address/create',
      update: 'address/update',
      makeDefault: 'address/makeDefault',
      updateShippingDetailsState: 'shipping/updateShippingDetailsState'
    }),
    getAddress () {
      let user = Object.assign({}, this.$store.state.user.current)
      let details = this.$refs.address_form.shipping.api_details
      if (details && typeof details !== 'string') {
        details = JSON.stringify(details)
      }

      return {
        customer_id: user.id,
        firstname: this.otherReceiver && this.$refs.address_form.shipping.firstname ? this.$refs.address_form.shipping.firstname : this.$store.state.user.current.firstname,
        lastname: this.otherReceiver && this.$refs.address_form.shipping.lastname ? this.$refs.address_form.shipping.lastname : this.$store.state.user.current.lastname,
        street: this.$refs.address_form.shipping.street,
        house: this.$refs.address_form.shipping.house,
        apartment: this.$refs.address_form.shipping.apartment,
        city: this.$refs.address_form.shipping.city,
        state: this.$refs.address_form.shipping.state,
        country: this.$refs.address_form.shipping.country,
        postcode: this.$refs.address_form.shipping.postcode,
        phone_number: this.otherReceiver && this.$refs.address_form.shipping.phone_number ? this.$refs.address_form.shipping.phone_number : this.$store.state.user.current.telephone,
        comment: this.$refs.address_form.shipping.comment,
        location_code : user.default_location_code,
        longitude: this.$refs.address_form.shipping.longitude,
        latitude: this.$refs.address_form.shipping.latitude,
        api_details: details,
        default_shipping: !!this.$refs.address_form.shipping.default_shipping
      }
    },
    displayAddressForm (payload) {
      this.fieldsType = payload.type
      this.addressFormDisplayed = true
      this.$nextTick(() => {
        this.$bus.$emit('customer-initialize-shipping-address-form', payload)
      })
    },

    submit () {
      if (this.$refs.address_form.$v.$invalid) {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('The selected address is not valid. Please, edit it or contact the support!'),
          action1: { label: this.$t('OK') }
        })
        return;
      }
      if (this.fieldsType === 'add') {
        this.addNewAddress()
      } else {
        this.editCurrentAddress()
      }
    },

    // Add new address
    addNewAddress () {
      this.create({ address: this.getAddress() })
        .then(async res => {
          this.$store.dispatch('notification/spawnNotification', {
            type: 'success',
            message: this.$t('Your address is added!'),
            action1: { label: this.$t('OK') }
          })
          if (res.id && res.default_shipping) {
            this.makeDefault({ address_id: res.id })
              .then(defaultAddress => {
                this.$bus.$emit('checkout-after-shippingDetails', defaultAddress);
                this.updateShippingDetailsState({
                  shipToMyAddress: true,
                  showNewAddressForm: false
                })
              })
          }
          this.closeAddressForm()
        })
        .catch(err => {
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: this.$t('Error has happened during adding the new address! Please, try again or contact the support!'),
            action1: { label: this.$t('OK') }
          })
        })
    },

    // Edit current address
    editCurrentAddress () {
      let editedAddress= this.getAddress()
      this.update({ address_id: this.$refs.address_form.address_id, address: editedAddress })
        .then(() => {
          this.$store.dispatch('notification/spawnNotification', {
            type: 'success',
            message: this.$t('Your address is updated!'),
            action1: { label: this.$t('OK') }
          })
          if (editedAddress.default_shipping) {
            this.makeDefault({ address_id: this.$refs.address_form.address_id })
          }
          this.closeAddressForm()
        })
        .catch(() => {
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: this.$t('Error is happened during updating the address!'),
            action1: { label: this.$t('OK') }
          })
        })
    },

    closeAddressForm () {
      this.addressFormDisplayed = false
      this.fieldsType = ''
    }
  },
  beforeDestroy () {
    this.$bus.$off('customer-display-shipping-address-form', this.displayAddressForm)
  }
}
